import {ChangeDetectorRef, Component} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CommonService} from "../../../../shared/services/common.service";
import {Store} from "@ngrx/store";
import * as moment from "moment/moment";
import {DropdownOption} from "../../../../../models/dropdown-option.model";
import {
  FetchCoachesFilterRequest,
  FetchSessionDeliveryFilterRequest,
  FetchSessionDetailsRequest,
  FetchSessionResourcesRequest,
  MarkAttendanceRequest,
  MarkParticipantDropoutRequest,
  UpdateSessionDetailsRequest
} from "../../core/sessions-list.actions";
import {Subject, takeUntil} from "rxjs";
import {
  coachesFilter,
  markAttendance,
  sessionDeliveryFilter,
  sessionDetails,
  sessionResources
} from "../../core/sessions-list.selectors";
import {ActivatedRoute, Router} from "@angular/router";
import {ResourcesModel} from "../../models/resources.model";
import {SelectionModel} from "@angular/cdk/collections";
import {profileData} from "../../../../shared/core/shared.selectors";
import {
  IndividualSessionDetailsComponent
} from "../individual-session-details/individual-session-details.component";
import { FetchGroupDetailsRequest } from "../../../group-details/core/group-details.actions";
import { groupDetails } from "../../../group-details/core/group-details.selector";
import {groupStatusColors, roles} from '../../../../shared/constants/common.constants';

@Component({
  selector: "app-session-details",
  templateUrl: "./session-details.component.html",
  styleUrls: ["./session-details.component.css"]
})
export class SessionDetailsComponent {
  selection = new SelectionModel<any>(true, []);
  errorMessages: any = {};
  minDate = '';
  maxDate = '';
  loading: boolean = false;
  sessionDeliveryOptions: DropdownOption[] = [];
  otherCoachesOptions: any[] = [];
  otherCoachesOptionsLoading: boolean = false;
  params: any;
  resourceData: ResourcesModel;
  role: number;
  sessionDetails: any;
  tableData: any[];
  dataSource: any[] = [];
  displayedColumns = [
    "participantName",
    "present",
    "adultsName",
    "sessionDetails",
    "actions"
  ];
  actionMenu = [
    {
      displayName: "Delete Attendance",
      icon: "",
      highLightColor: "",
      handleClick: (data, index) => this.deleteAttendance(data, index)
    },
    {
      displayName: "Mark Dropout",
      icon: "",
      highLightColor: "",
      handleClick: (data) => this.markDropOut(data)
    }
  ];
  sessionFormatOptions = [
    {
      key: 1,
      value: "Group",
    },
    {
      key: 2,
      value: "Individual family",
    },
  ];
  coachesOptions = [];
  errorMessageMap = {
    sessionStartDate: {
      required: "This field is required."
    },
    startTime: {
      required: "This field is required."
    },
    sessionFormat: {
      required: "Required."
    },
    sessionDelivery: {
      required: "Required."
    },
    duration: {
      required: "Required."
    },
    otherCoaches: {
      required: "This field is required."
    },
    notes: {
      required: "This field is required."
    },
  };
  attendanceFormGroup = new FormGroup<any>({});
  isPresentValueMap = {
    1: true,
    2: false
  }

  isPresentValueReverseMap = {
    true: 1,
    false: 2
  }

  form = new FormGroup<any>({
    sessionStartDate: new FormControl({value: "", disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
    startTime: new FormControl({value: "", disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
    sessionFormat: new FormControl({value: null, disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
    sessionDelivery: new FormControl({value: null, disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
    duration: new FormControl({value: null, disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
    notes: new FormControl({value: null, disabled: false}),
    coaches: new FormControl([]),
  });
  isCoachSelectionDisabled: boolean = false;
  isOtherCoachSelectionEnabled = false;
  markAttendanceLoading = false;
  groupStatus: number=null;

  private readonly onDestroy: Subject<any> = new Subject<any>();
  groupDetails: any;

  constructor(
    private commonService: CommonService,
    private store: Store,
    private route: ActivatedRoute,
    private router: Router,
    private cdRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.store.dispatch(FetchSessionDeliveryFilterRequest());

    this.route.paramMap.pipe(takeUntil(this.onDestroy))
      .subscribe((params: any) => {
        this.params = params?.params;
      });

      const groupDetailsPayload = {
        groupId: this.params.groupId,
      };
      this.store.dispatch(FetchGroupDetailsRequest({payload: groupDetailsPayload}));

    const payload = {
      sessionId: this.params.sessionId,
      groupId: this.params.groupId,
    }

    this.store.dispatch(FetchSessionDetailsRequest({payload}))

    if (this.params.sessionId) {
      this.fetchResources();
    }

    this.store.select(profileData).pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.role = data.profile?.role;
      });

    this.store.select(markAttendance)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.markAttendanceLoading = data.loading;
      })

    this.store.select(sessionDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.form.enable();
        this.attendanceFormGroup = new FormGroup<any>({});
        this.attendanceFormGroup.enable();

        this.loading = data?.loading;
        this.sessionDetails = data?.details;

        if (!data) {
          return;
        }

        if (this.sessionDetails?.isComplete || this.groupStatus !== 2) {
          this.form.disable();
          this.attendanceFormGroup.disable();
        }

        this.minDate = moment(this.sessionDetails?.prevStartDate).add(1, 'd')
                         .toISOString() || moment()
                         .subtract(6, "months").toISOString();

        this.maxDate = moment(this.sessionDetails?.nextStartDate)
                         .subtract(1, 'd').toISOString() || moment()
                         .add(6, "months").toISOString();


        this.coachesOptions = this.sessionDetails?.groupCoaches?.map((item) => ({
          key: item.id,
          value: item.name,
          checked: this.sessionDetails?.coachAttendance.find((value) => value.id == item.id)
        }))
        if (this.coachesOptions?.length) {
          this.form.controls["coaches"].setValue(this.coachesOptions.filter((item) => item.checked)
            .map((item) => item.key));
        }

        // find other coaches attendance
        const otherCoachAttendance = this.sessionDetails?.coachAttendance.filter((item) => !this.sessionDetails?.groupCoaches.find((value) => value.id == item.id));
        if (otherCoachAttendance?.length) {
          this.isOtherCoachSelectionEnabled = true;
          this.onSelectOtherCoaches({checked: true}, otherCoachAttendance.map((item) => item.id))

          if (this.sessionDetails?.isComplete) {
            this.form.controls['otherCoaches'].disable();
          }
        } else {
          this.isOtherCoachSelectionEnabled = false;
        }


        this.form.patchValue({
          sessionStartDate: this.sessionDetails?.startDate,
          startTime: this.sessionDetails?.startDate,
          sessionFormat: this.sessionDetails?.format,
          sessionDelivery: this.sessionDetails?.location,
          duration: this.sessionDetails?.duration,
          notes: this.sessionDetails?.note
        }, {emitEvent: true});

        this.form.markAsPristine();

        this.dataSource = data?.details?.sessionAttendance.map((item) => ({
          ...item,
          id: item.id,
          sessionDetails: "Session Details",
          attendance: this.isPresentValueReverseMap[item.isPresent],
          adults: item.adultsAttendance.map((i) => {
            if (i.isLar) {
              return i.id
            }
          }).filter((d) => d != undefined),
          adultsName: item.adultsAttendance.map((i) => {
            if (i.isLar) {
              return `${i.firstName} ${i.lastName}(LAR)`
            }
            return `${i.firstName} ${i.lastName}`;
          }).join(", ")
        }))

        this.prepareFormControls();
      })

    this.store.select(sessionDeliveryFilter)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.sessionDeliveryOptions = data?.list;
        this.cdRef.detectChanges();
      });

    this.store.select(coachesFilter)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.otherCoachesOptionsLoading = data?.loading;
        this.otherCoachesOptions = data?.list?.filter((otherCoach) => {
          return !this.coachesOptions?.find((coach) => coach.key === otherCoach.key);
        }).map((option) => ({
          key: option.key,
          value: option.value,
          disabled: false
        }));
        this.checkCoachSelection();

        this.cdRef.detectChanges();
      });

    this.store.select(sessionResources).pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.resourceData = data;
      });

    this.form.controls["coaches"].valueChanges.pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        // Disable unselected options in otherCoachesOptions
        this.otherCoachesOptions = this.otherCoachesOptions.map(option => ({
          ...option,
        }));
        this.checkCoachSelection();
      });

      this.store.select(groupDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (!data || !data?.details) {
          return;
        }
        this.groupDetails = data.details;
        this.groupStatus = data.details.status;
        if(this.groupStatus !== 2){
          this.form.disable();
        }
      })
  }

  fetchResources(pageNumber = 1, limit = 10) {
    this.store.dispatch(FetchSessionResourcesRequest({
      payload: {
        pageNumber,
        sortColumn:"order",
        sortOrder:1,
        limit,
        filters: {
          sessions: [this.params.sessionId],
          groups: [this.params.groupId]
        }
      }
    }));

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();

        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  onScroll() {
    if (this.resourceData?.hasNext && !this.resourceData?.loading) {
      this.fetchResources(this.resourceData.pageNumber + 1, this.resourceData.limit);
    }
  }

  onSaveSchedule() {
    if (this.commonService.hasDirtyAndInvalidValues(null, this.form).length) {
      this.checkForErrors();
      return;
    }

    if (!this.form.dirty) {
      return;
    }

    const {
      sessionStartDate,
      startTime,
      sessionFormat,
      sessionDelivery,
      duration,
      coaches,
      otherCoaches,
      notes
    } = this.form.getRawValue();

    let selectedCoaches = []
    let selectedOtherCoaches = []
    let removedCoachAttendances = []

    // find coaches whose attendance removed
    const removedAttendanceCoaches = this.sessionDetails?.coachAttendance.filter((item) => !coaches?.includes(item.id) && !otherCoaches?.includes(item.id));

    if (coaches?.length > 0) {
      selectedCoaches = coaches.map(eachCoach => {
        return {coachId: eachCoach, isPresent: true};
      });
    }

    if (otherCoaches?.length > 0) {
      selectedOtherCoaches = otherCoaches.map(eachCoach => {
        return {coachId: eachCoach, isPresent: true};
      });
    }

    if (removedAttendanceCoaches?.length) {
      removedCoachAttendances = removedAttendanceCoaches.map(eachCoach => {
        return {coachId: eachCoach.id, isPresent: false};
      });
    }

    const payload = {
      startDate: [
        moment(sessionStartDate)?.toISOString()?.split('T')[0],
        moment(startTime)?.toISOString().split('T')[1]
      ].join('T'),
      format: sessionFormat,
      location: sessionDelivery,
      duration,
      coachAttendance: [
        ...(selectedCoaches || []), ...(selectedOtherCoaches || []),
        ...(removedCoachAttendances || [])
      ],
      note: notes,
      sessionId: +this.params.sessionId,
      groupId: +this.params.groupId,
    }

    // remove control with value null
    for (const payloadKey in payload) {
      if (!payload[payloadKey]) {
        delete payload[payloadKey]
      }
    }

    if (!payload?.coachAttendance?.length) {
      delete payload.coachAttendance
    }

    this.store.dispatch(UpdateSessionDetailsRequest({payload}))
  }

  onSaveAttendance() {
    const sessionAttendance = this.dataSource.map((item) => {
        const {startDate, otherAdultsAttending, otherChildrenAttending, ...sessionData} = item.sessionData;

        return {
          participantId: item.id,
          sessionData: {
            ...sessionData,
            coachAttendance: sessionData.coachAttendance.map(o => ({
              coachId: o.id,
              isPresent: o.isPresent
            })),
            meetingOn: startDate
          },
          isPresent: this.isPresentValueMap[this.attendanceFormGroup.controls['' + item.id]?.value] !== undefined ? this.isPresentValueMap[this.attendanceFormGroup.controls['' + item.id]?.value] : null,
        }
      }
    )

    const payload = {
      participantAttendance: [
        ...sessionAttendance
      ],
      sessionId: +this.params.sessionId,
      groupId: +this.params.groupId,
    }
    this.store.dispatch(MarkAttendanceRequest({payload}))
  }

  onSessionDetailsClicked(details) {
    this.commonService.openDialog({
      data: {
        component: IndividualSessionDetailsComponent,
        sessionDetails: details,
        sessionId: this.params.sessionId,
        groupId: this.params.groupId,
        groupStatus: this.groupStatus,
        sessionCompleted: this.sessionDetails.isComplete,
        clientId: this.role === roles.superAdmin ? this.groupDetails?.clientId : null,
      }
    })
  }

  onCoachSelectionChange(option) {
    option.checked = !option.checked;
    this.form.controls["coaches"].setValue(this.coachesOptions.filter((item) => item.checked)
      .map((item) => item.key));
    this.form.controls['coaches'].markAsDirty();
  }

  closeSession() {
    this.form.disable();
    this.attendanceFormGroup.disable();
    const payload = {
      isComplete: true,
      groupId: this.params.groupId,
      sessionId: this.params.sessionId
    }
    this.store.dispatch(UpdateSessionDetailsRequest({payload}));
  }

  restartSession() {
    this.form.enable();
    this.attendanceFormGroup.enable();
    const payload = {
      isComplete: false,
      groupId: this.params.groupId,
      sessionId: this.params.sessionId
    }
    this.store.dispatch(UpdateSessionDetailsRequest({payload}));
  }

  onSelectOtherCoaches(event, defaultValues = null) {
    this.store.dispatch(FetchCoachesFilterRequest({
      payload: {
        clientId: this.role === roles.superAdmin ? this.groupDetails?.clientId : null,
      }
    }));
    if (event?.checked) {
      this.form.addControl(
        "otherCoaches",
        new FormControl({value: defaultValues, disabled: false})
      );

      this.form.controls["otherCoaches"].valueChanges.pipe(takeUntil(this.onDestroy))
        .subscribe((data) => {
          this.checkCoachSelection();
        });
    } else {
      this.form.removeControl("otherCoaches");
    }
    this.checkCoachSelection();
  }

  checkCoachSelection() {
    const defaultCoachCount = +this.form.controls["coaches"].value?.length;
    const otherCoachCount = +this.form.controls["otherCoaches"]?.value?.length;
    this.isCoachSelectionDisabled = (defaultCoachCount + otherCoachCount) === 6;

    // Disable unselected options in otherCoachesOptions
    if (this.form.controls["otherCoaches"]) {
      this.otherCoachesOptions = this.otherCoachesOptions.map(option => ({
        ...option,
        disabled: this.isCoachSelectionDisabled && !this.form.controls["otherCoaches"]?.value.includes(option.key),
      }));
    }
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  prepareFormControls() {
    this.dataSource?.forEach((item) => {
      this.attendanceFormGroup.addControl("" + item.id, new FormControl(item.attendance));
    });
  }

  deleteAttendance(data: any, selectedIndex: number) {
    this.attendanceFormGroup.controls['' + data.id].setValue(null);
    const {startDate, otherAdultsAttending, otherChildrenAttending, ...sessionData} = this.dataSource[selectedIndex].sessionData;

    const sessionAttendance = {
      participantId: this.dataSource[selectedIndex].id,
      sessionData: {
        ...sessionData,
        coachAttendance: sessionData.coachAttendance.map(o => ({
          coachId: o.id,
          isPresent: o.isPresent
        })),
        meetingOn: startDate
      },
      isPresent: this.isPresentValueMap[this.attendanceFormGroup.controls['' + this.dataSource[selectedIndex].id]?.value] !== undefined ? this.isPresentValueMap[this.attendanceFormGroup.controls['' + this.dataSource[selectedIndex].id]?.value] : null,
    }

    const payload = {
      participantAttendance: [
        {...sessionAttendance}
      ],
      sessionId: +this.params.sessionId,
      groupId: +this.params.groupId,
    }
    this.store.dispatch(MarkAttendanceRequest({payload}))
  }

  markDropOut(data: any) {
    this.store.dispatch(MarkParticipantDropoutRequest({payload: {groupId: +this.params.groupId, status: 3, userId: data.id, sessionId: +this.params.sessionId,}}))
  }

  markParticipantAsActive(data: any) {
    this.store.dispatch(MarkParticipantDropoutRequest({payload: {groupId: +this.params.groupId, status: 1, userId: data.id, sessionId: +this.params.sessionId,}}))
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

  protected readonly groupStatusColors = groupStatusColors;
}
